export default __webpack_public_path__ + "static/media/date-dropdown.5f460d28.svg";